import React, { useState } from 'react';
import { Button, Modal, Popconfirm } from 'antd';
import { t } from '../../../languages';


const DeleteButtonWithConfirm = ({ lang, text, message, onDelete }) => {

  const handleDeleteClick = () => {
    onDelete();
  };

  return (
    <>
      <Popconfirm placement="top" title={t(lang, message)} onConfirm={handleDeleteClick} okText={t(lang,'delete')} cancelText={t(lang,'cancel')}>
        <Button danger ghost className="button-danger">
          {t(lang, text)}
        </Button>
      </Popconfirm>

    </>
  );
};

export default DeleteButtonWithConfirm;